// generated by the plop

export class GetMediators {
  static type = '[mediators] GetMediators';

  constructor(public search = '') {
  }
}
